import { createApi } from '@reduxjs/toolkit/query/react';
import { sortPlaces } from 'features/UserMenu/features/Places/utils/places.utils';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';

export const placesApi = createApi({
  reducerPath: 'placesApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Places'],
  endpoints: (builder) => ({
    getFusionPlaces: builder.query({
      query: () => ({
        url: '/users/places',
      }),
      transformResponse: (response) => sortPlaces(response?.places || []),
      providesTags: ['Places'],
    }),
    addFusionPlaces: builder.mutation({
      query: (places) => ({
        url: '/users/places',
        method: 'POST',
        data: { places },
      }),
      invalidatesTags: ['Places'],
    }),
  }),
});

export const { useGetFusionPlacesQuery, useAddFusionPlacesMutation } = placesApi;
